//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "taocanxiangmu",
  data() {
    return {
      content: [],
    };
  },
  methods: {
    init: function () {
      this.$HTTP.HttpPost("/Member/Card/getItemList", {}).then((data) => {
        this.content = data.data.data;
      });
    },
  },
  mounted() {
    this.init();
  },
};



// WEBPACK FOOTER //
// ./src/components/taocanxiangmu.vue